import React, { useContext } from "react";

import { templates } from "@reactivated";

import { ReactivatedContext as Context } from "../../context";
import { ContactSubscribeBlock } from "../ContactSubscribeBlock";
import { RichText } from "../RichText";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

type PressReleasePage = templates.PressReleasePageTemplate["page"];

const PressRelease2024 = (props: { page: PressReleasePage }) => (
    <>
        <article
            className={styles.container}
            itemScope={true}
            itemType="http://schema.org/Article"
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <h1 className={styles.header}>{props.page.title}</h1>
                    {props.page.caption && (
                        <RichText
                            className={styles.captionText}
                            value={props.page.caption.html}
                        />
                    )}
                    {props.page.body && (
                        <RichText value={props.page.body.html} />
                    )}
                </div>
            </div>
        </article>
        <ContactSubscribeBlock value={{ ...props.page.contact_subscribe }} />
    </>
);

const PressRelease2026 = (props: { page: PressReleasePage }) => (
    <>
        <article
            className={styles.container2026}
            itemScope={true}
            itemType="http://schema.org/Article"
        >
            <div className={styles.inner2026}>
                {props.page.parent_page_info.url && (
                    <a
                        href={props.page.parent_page_info.url}
                        className={styles.backLink}
                    >
                        <Svg
                            name="caret-right"
                            className={styles.backLinkIcon}
                        />
                        {props.page.parent_page_info.title}
                    </a>
                )}
                <div className={styles.textHeader}>
                    <h1 className={styles.header2026}>{props.page.title}</h1>
                    {props.page.caption.html && (
                        <RichText
                            className={styles.captionText2026}
                            value={props.page.caption.html}
                        />
                    )}
                </div>
                {props.page.body && (
                    <div className={styles.body2026}>
                        <RichText value={props.page.body.html} />
                    </div>
                )}
            </div>
        </article>
        <ContactSubscribeBlock value={{ ...props.page.contact_subscribe }} />
    </>
);

export const PressRelease = (props: { page: PressReleasePage }) => {
    const isV2026 = useContext(Context).DESIGN_VERSION === "v2026";

    return isV2026 ? (
        <PressRelease2026 page={props.page} />
    ) : (
        <PressRelease2024 page={props.page} />
    );
};
